import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { headers } from "../apiConfig";

import { getServerUrl } from '../../Utils/serverSelector'; 

// Асинхронное действие для загрузки sitemap.xml
export const fetchSitemap = createAsyncThunk(
  "sitemap/fetchSitemap",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${getServerUrl()}/sitemap.xml`, {
        headers: {
          ...headers,
          "Content-Type": "application/xml",
        },
      });
      return response.data;
    } catch (error) {
      // console.error("Ошибка загрузки sitemap.xml:", error);
      return rejectWithValue(error.response?.data || "Ошибка при загрузке Sitemap");
    }
  }
);

const sitemapSlice = createSlice({
  name: "sitemap",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSitemap.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSitemap.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSitemap.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default sitemapSlice.reducer;
